import React from "react";
import { Select, Divider, Icon, Input, Modal, Alert, Form } from "antd";

class BrdgxBankSelector extends React.Component {
    state= {
        newBankName:'',
        visibleNewBankName: false,
        errorNewBankName:''
    }

    onNewBankNameChange = (ev) => {
        this.setState({
            newBankName: ev.target.value,
        })
    }
    showAddBankNameModal = (ev) => {
        this.setState({
            newBankName:'',
            errorNewBankName:'',
            visibleNewBankName: true
        })
    }
    handleCancel = () => {
        this.setState({
            newBankName:'',
            errorNewBankName:'',
            visibleNewBankName: false
        })
    }


    handleAddBankNameModal = () => {
        let errorNewBankName = '';
        if(!this.state.newBankName) {
            errorNewBankName = "Please input new bank name.";
        } else if(this.state.newBankName.trim().length < 3){
            errorNewBankName = "The length of bank must contain at least 3 characters.";
        } else {
            errorNewBankName ='';
        }
        let visibleNewBankName = errorNewBankName != '';
        this.setState({
            errorNewBankName: errorNewBankName,
            visibleNewBankName: visibleNewBankName
        })
        if(!visibleNewBankName) {
            this.props.addNewBankName(this.state.newBankName);
        }
    }

  render() {
    const banks = this.props.banks;
    return (
        <>
        <Modal
            title="Add new bank"
            visible={this.state.visibleNewBankName}
            onOk={this.handleAddBankNameModal}
            onCancel={this.handleCancel}
        >
            {this.state.errorNewBankName && <Alert message={this.state.errorNewBankName} type="error" />}
            <Form.Item>
            <Input placeholder="New bank name" title="New bank name" value={this.state.newBankName} onChange={this.onNewBankNameChange.bind(this)}/>
            </Form.Item>
        </Modal>
      <Select
        showSearch
        style={{ width: 200, ...this.props.style }}
        size={this.props.size}
        placeholder={this.props.placeholder}
        optionFilterProp="children"
        onChange={this.props.onChange}
        value={this.props.value || undefined}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        dropdownRender={banks => (
            !this.props.isPaymentGlobal ?
                <div>
                    {banks}
                </div>
                :
                <div>
                    {banks}
                    <Divider style={{margin: '0 0'}}/>
                    <a>
                        <div
                            style={{padding: '4px 8px', cursor: 'pointer'}}
                            onMouseDown={e => e.preventDefault()}
                            onClick={this.showAddBankNameModal}
                        >
                            <Icon type="plus"/> Add new bank
                        </div>
                    </a>
                </div>
        )}
        mode={this.props.mode || "default"}
      >
        {banks.map((bank) => {
          return (
            <Select.Option value={bank.code} key={bank.code}>
              {bank.value}
            </Select.Option>
          );
        })}
      </Select>
        </>
    );
  }
}

export default BrdgxBankSelector;
